import AuthService from '@/services/auth/auth'
import { jwtDecode } from 'jwt-decode'
import { createMongoAbility } from '@casl/ability'

const authService = new AuthService()

export default {
    namespaced: true,
    state: {
        token: '',
        refreshToken: '',
        error: false,
        errorCode: '',
        ability: new createMongoAbility()
    },
    mutations: {
        setToken(state, payload) {
            state.token = payload.token
            state.refreshToken = payload.refreshToken
            state.error = false
        },
        logout(state) {
            state.token = ''
            state.refreshToken = ''
            state.error = false
        },
        authError(state, payload) {
            state.token = ''
            state.refreshToken = ''
            state.error = payload.error
            state.errorCode = payload.errorCode
        }
    },
    actions: {
        async signIn({ commit, dispatch }, user) {
            try {
                commit('setLoading', true, { root: true })
                const tokenResponse = await authService.getToken(user)
                commit('auth/setToken', { 'token': tokenResponse.token, 'refreshToken': tokenResponse.refresh_token }, { root: true })
            } catch(e) {
                const error = e.code ? e.code : e.status
                commit('auth/authError', { 'error': true, 'errorCode': error }, { root: true })
            } finally {
                commit('setLoading', false, { root: true })
            }
        },
        async signOut({commit, state}) {
            try {
                commit('setLoading', true, { root: true })
                await authService.setTokenExpired(state.token, state.refreshToken)
                commit('auth/logout', null, { root: true })
            } catch(e) {
            } finally {
                commit('setLoading', false, { root: true })
            }
        },
        async refreshToken({ commit, dispatch, state }) {
            try {
                commit('setLoading', true, { root: true })
                const tokenResponse = await authService.refreshToken(state.token, state.refreshToken)
                commit('auth/setToken', { 'token': tokenResponse.token, 'refreshToken': tokenResponse.refresh_token }, { root: true })
            } catch(e) {
                commit('auth/logout', null, { root: true })
            } finally {
                commit('setLoading', false, { root: true })
            }
        }
    },
    getters: {
        getCurrentUser: state => state.token ? jwtDecode(state.token) : null,
        getAbility: state => state.ability
    }
}
